var mapObject = require('./map_object');

module.exports = function(object) {
  return mapObject(object, function(value, _) {
    return value;
  });
};
